import React from "react";
import {
  FaLandmark,
  FaNetworkWired,
  FaChartBar,
  FaHandsHelping,
  FaUserCheck,
  FaChartLine,
  FaPrayingHands,
} from "react-icons/fa";
import HeroSection from "../../components/heros/HeroSection";
import { Link } from "react-router-dom";
import Button from "../../components/common/Button/Button";
import BenefitCard from "../../components/partner/BenefitCard/BenefitCard";
import "./TemplesPage.css";
import "../SellersPage/SellersPage.css";
import TimelineStep from "../../components/partner/TimelineStep/TimelineStep";
import InstitutionTestimonialCard from "../../components/partner/TestimonialCard/InstitutionTestimonialCard";
import { useEffect, useState, useRef } from "react";
import { useViewTransitionState } from "react-router-dom";
import { useScrollProgress } from "../../hooks/useScrollProgress";
import heroImage from "../../assets/hero-seller.png";
import FinalCta from "../../components/partner/TempleCta/PartnerWithUsCta";
import HowPartnershipWorks from "../../components/temple/HowItWorks/TimelineHowItWorks/HowPartnershipWorks";
const heroData = {
    titleLine1: "Partner with",
    titleLine2: "Vanidya",
    subtitle:
        "Empower your society, institution, or spiritual group with trusted Satvik groceries, organic foods, pooja essentials, and spiritual books—customized for your community’s values.",
    ctaText: "Explore Community Partnership",
    backgroundImageUrl: "/images/temple-hero.jpg",
};

const benefitsData = [
    {
        icon: <FaNetworkWired />,
        title: "Custom Group Catalogs",
        description:
            "Get a handpicked catalog tailored to your community’s dietary rules, cultural practices, and festivals—Satvik, Jain, organic, vegan, or traditional.",
    },
    {
        icon: <FaHandsHelping />,
        title: "Simplified Festival & Ritual Planning",
        description:
            "Easily organize bulk orders for pooja kits, festival needs, or group rituals—delivered directly to your location.",
    },
    {
        icon: <FaLandmark />,
        title: "Transparent Process & Dedicated Support",
        description:
            "Work with our team to verify product details, delivery, and event needs—enjoy clear communication and responsive service.",
    },
];

const partnershipSteps = [
    {
        step: "1",
        title: "Request a Custom Solution",
        color: "#B25F30",
        desc: [
            "Share your community’s dietary and ritual needs with Vanidya.",
            "Co-create a catalog for members: Satvik foods, pooja essentials, books, and more.",
            "Get a dedicated support contact for ongoing coordination.",
        ],
        icon: <FaUserCheck />,
    },
    {
        step: "2",
        title: "Group Order & Delivery",
        color: "#DF8D44",
        desc: [
            "Order in bulk for events or regular needs—track and manage group orders with ease.",
            "Ensure all products are verified for ingredients and authenticity.",
            "Choose from home delivery, centralized pickup, or event-specific logistics.",
        ],
        icon: <FaChartLine />,
    },
    {
        step: "3",
        title: "Empower Your Community",
        color: "#db9039",
        desc: [
            "Make pure, culturally appropriate products accessible to all your members.",
            "Support wellness, tradition, and harmony in your group.",
            "Get insights and reports to streamline future events.",
        ],
        icon: <FaPrayingHands />,
    },
];

const templeTestimonials = [
  {
    temple: "Sri Venkateswara Temple, Tirupati",

    quote:
      "Vanidya’s monthly payouts have funded free meals for hundreds. We now have a sustainable, digital income stream for the temple.",
  },

  {
    temple: "Mahalakshmi Temple, Mumbai",

    quote:
      "Our devotees enjoy trusted sellers and better prices. Commissions are transparent, and every month we invest in community welfare.",
  },
];

const TimelineStepWrapper = ({ stepData, index }) => {
  const stepRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.5 }
    );

    if (stepRef.current) {
      observer.observe(stepRef.current);
    }

    return () => {
      if (stepRef.current) {
        observer.unobserve(stepRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={stepRef}
      className={`timeline-step-wrapper ${isVisible ? "is-visible" : ""}`}
    >
      <TimelineStep
        step={stepData}
        index={index}
        icon={stepData.icon}
        color={stepData.color}
      />
    </div>
  );
};

const ForTemplesPage = () => {
  const timelineRef = useRef(null);
  const scrollProgress = useScrollProgress(timelineRef);

  const handleScroll = () => {
    document
      .getElementById("how-it-works-temples")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="for-temples-page">
      <HeroSection
        titleLine1={heroData.titleLine1}
        titleLine2={heroData.titleLine2}
        subtitle={heroData.subtitle}
        ctaText={heroData.ctaText}
        onCtaClick={handleScroll}
        backgroundImageUrl={heroImage}
      />

      <section className="page-section benefits-section_23">
        <h2 className="_hTitle_s5E_ section-title">
          Why Partner with Vanidya?
        </h2>
        <p className="_hSubtitle_t6F_ section-subtitle">
          Empower your community's mission with a modern, transparent, and
          community-focused platform.
        </p>
        <div className="benefits-flex-container" style={{ paddingTop: "0px" }}>
          {benefitsData.map((benefit, index) => (
            <BenefitCard
              key={benefit.title}
              icon={benefit.icon}
              title={benefit.title}
              description={benefit.description}
              animationDelay={0.1 + index * 0.15}
            />
          ))}
        </div>
      </section>

      <HowPartnershipWorks />

      <FinalCta />
    </div>
  );
};

export default ForTemplesPage;
